import { InfoIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VALID_SPACE_TOKENS = ['200', '400', '800', '1100', '1400', '1500'];
const getPaddingInlineStart = paddingLeft => {
  const token = (paddingLeft || 200).toString();
  if (!VALID_SPACE_TOKENS.includes(token)) {
    // If the token is invalid, fall back to the default token
    return '200';
  }
  return token;
};

// TODO: move both options into a single component and extract the formatted messages & link functions based on the routing source
const TicketsTeamOption = ({
  option
}) => {
  const paddingInlineStart = getPaddingInlineStart(option.paddingLeft);
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "end",
    "data-test-id": "reassignment-dropdown-team",
    justifyContent: "space-between",
    paddingInlineStart: paddingInlineStart,
    paddingInlineEnd: "400",
    paddingBlock: "200",
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'routing-ui.users-and-teams.tooltips.team-no-service-seat-user-routing.description'
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlock: "0",
          children: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: getUsersSeatsUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'routing-ui.users-and-teams.tooltips.team-no-service-seat-user-routing.manage-link'
            })
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: InfoIcon
      })
    })]
  });
};
TicketsTeamOption.displayName = 'TicketsTeamOption';
const InboxTeamOption = ({
  option
}) => {
  const paddingInlineStart = getPaddingInlineStart(option.paddingLeft);
  return /*#__PURE__*/_jsxs(TFlex, {
    "data-test-id": "reassignment-dropdown-team",
    justifyContent: "space-between",
    paddingInlineStart: paddingInlineStart,
    paddingInlineEnd: "400",
    paddingBlock: "200",
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'routing-ui.users-and-teams.tooltips.team-free-user-routing.description'
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlock: "0",
          children: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: getPaidUserSettingsUrl(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'routing-ui.users-and-teams.tooltips.team-free-user-routing.manage-link'
            })
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: InfoIcon,
        marginInlineEnd: "200"
      })
    })]
  });
};
InboxTeamOption.displayName = 'InboxTeamOption';

// TODO: move this logic & copy into conversations-routing-lib
const TeamOption = ({
  option,
  routingSource
}) => {
  const Component = routingSource === ROUTING_SOURCE.HELP_DESK ? TicketsTeamOption : InboxTeamOption;
  return /*#__PURE__*/_jsx(Component, {
    option: option
  });
};
TeamOption.displayName = 'TeamOption';
export default TeamOption;